export { default } from './Subject';
export { default as datamap } from './Subject.datamap';
export type { PageData } from './Subject.datamap';
